import { render } from "./UserNickGrade.vue?vue&type=template&id=797965c7"
import script from "./UserNickGrade.vue?vue&type=script&lang=js"
export * from "./UserNickGrade.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__